import { render } from "./ConfigSelect.vue?vue&type=template&id=55e7ecc9&scoped=true&ts=true"
import script from "./ConfigSelect.vue?vue&type=script&lang=ts"
export * from "./ConfigSelect.vue?vue&type=script&lang=ts"

import "./ConfigSelect.vue?vue&type=style&index=0&id=55e7ecc9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/octopus-lobby/octopus-lobby/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e7ecc9"]])

export default __exports__